import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { getCurrentRichContent } from "../helpers/richContentHelpers";

const productPageData = (id) => {
    const data = useStaticQuery(
        graphql`
            {
                allWpPage {
                    edges {
                        node {
                            id
                            template {
                                ... on WpTemplate_Product {
                                    productRichContent {
                                        hero {
                                            badge
                                            category
                                            header
                                            secondHeader
                                            text
                                            ecosystemHeader
                                            ecosystemDescription
                                            ecosystemFooterText
                                            ecosystemLogos {
                                                image {
                                                    ...wpImageFluid
                                                }
                                            }
                                            image {
                                                localFile {
                                                    extension
                                                    childImageSharp {
                                                        gatsbyImageData(
                                                            width: 1800
                                                            placeholder: BLURRED
                                                            quality: 100
                                                        )
                                                    }
                                                }
                                            }
                                        }
                                        anchorNav {
                                            label
                                            target
                                        }
                                        # SECTION: Feature Sections
                                        featureSections {
                                            imageSection {
                                                category
                                                title
                                                text
                                                slug
                                                variant
                                                image {
                                                    ...wpImageFluid
                                                }
                                                items {
                                                    category
                                                    title
                                                    text
                                                    button {
                                                        variant
                                                        link {
                                                            target
                                                            title
                                                            url
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        testimonials {
                                            header
                                            items {
                                                quote
                                                companyLogo {
                                                    ...wpImageFluid
                                                }
                                            }
                                        }
                                        securitySection {
                                            slug
                                            header
                                            description
                                            certificationText
                                            certificationBadges {
                                                badge {
                                                    ...wpImage
                                                }
                                            }
                                            features {
                                                icon {
                                                    ...wpImage
                                                }
                                                text
                                            }
                                        }

                                      # SECTION: FAQ
                                      faqSection {
                                        header
                                        items {
                                          question
                                          answer
                                        }
                                    }
                                    }
                                }
                        }
                    }
                }
            }
                                        }
`
    );
    return getCurrentRichContent(data, id, "productRichContent");
};

export { productPageData };
